import logo from './logo.svg';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Plans from './pages/Plans';
import Login from './pages/Login';
import CustomerDashboard from './pages/CustomerDashboard';
import CustomerAttendance from './pages/CustomerAttendance';
import CustomerMyPlan from './pages/CustomerMyPlan';
import CustomerBMICalculator from './pages/CustomerBMICalculator';
import TrainerDashboard from './pages/TrainerDashboard';
import AdminDashboard from './pages/AdminDashboard';
import AllClients from './pages/AllClients';
import About from './pages/About';
import PTClients from './pages/PTClients';
import Trainers from './pages/Trainers';
import AllCoins from './pages/AllCoins';
import Analytics from './pages/Analytics';
import CustomerCoins from './pages/CustomerCoins';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import RemainingIds from './pages/RemainingIds';
import Message from './pages/Message';
import ActiveClients from './pages/ActiveClients';
import ClientDetails from './pages/ClientDetails';
import DailyMessage from './pages/DailyMessage';

// Add this component somewhere in your JSX, ideally near the root of your app:




function App() {
  return (
    <div className=" min-h-[100vh] bg-gray-900 text-white">
      <ToastContainer />
      <Navbar/>
      
      <Routes>
        <Route
          path="/"
          element={<Home/>}
          />
          <Route
          path="/plans"
          element={<Plans/>}
          />
          <Route
          path="/login"
          element={<Login/>}/>
          <Route
          path="customerdashboard"
          element= {<CustomerDashboard/>}/>
          <Route
          path="customerattendance"
          element={<CustomerAttendance/>}/>
          <Route
          path="customermyplan"
          element={<CustomerMyPlan/>}/>
          <Route
          path="customerbmicalculator" element={<CustomerBMICalculator/>}/>
          <Route
          path="trainerdashboard"
          element={<TrainerDashboard/>}/>
          <Route
          path="admindashboard" element={<AdminDashboard/>}/>
           <Route
          path="whatsappdashboard" element={<Message/>}/>
           <Route
          path="/about"
          element={<About/>}/>
          <Route
          path='allclients' element={<AllClients/>}/>
          <Route
          path='activeclients' element={<ActiveClients/>}/>
          <Route
          path="ptclients" element={<PTClients/>}/>
          <Route
          path="trainers" element={<Trainers/>}/>
          <Route
          path="allcoins" element={<AllCoins/>}/>
          <Route
          path="remainingids" element={<RemainingIds/>}/>
          <Route
          path="analytics" element={<Analytics/>}/>
           <Route
          path="customercoins" element={<CustomerCoins/>}/>
          <Route
          path="/clients/:clientId" element={<ClientDetails/>}/>
          <Route
          path="/daily-message" element={<DailyMessage/>}/>
      </Routes>

      <Footer/>
    </div>
  );
}

export default App;
